module.exports = __webpack_public_path__ + "img/Bart Simpson-256.15d0d9bf.png";